import axiosInstance from './axiosCreator';

export const fetchDailyChatResponseCount = async (): Promise<{
  responsesToday: number;
  dailyLimit: number | null;
  responsesRemaining: number | null;
  resetAt: string | null;
  accessLevel: string;
}> => {
  const response = await axiosInstance.get('/chat/responses/today');
  return response.data.data;
};
